const NOTIFY_MESSAGES: Record<string, string> = {
  'email-already-verified': 'Email already verified',
  'email-verified': 'Email verified. Please open app to complete signup',
};

const formatUnknownNotifySlug = (slug: string): string => {
  const text = slug.replace(/-/g, ' ');
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const getNotifyMessage = (slug: string): string => {
  const normalizedSlug = slug.replace(/\/$/, '');
  return NOTIFY_MESSAGES[normalizedSlug] ?? formatUnknownNotifySlug(normalizedSlug);
};

export const getNotifyPathMatch = (pathname: string): string | null => {
  const match = pathname.match(/^\/notify\/(.+)$/);
  if (!match) {
    return null;
  }

  const slug = match[1].replace(/\/$/, '');
  return slug || null;
};
